<template>
  <div id="app" :class="app_classes">    

    <div class="banner_ps" v-if="this.$store.state.ps">
      27 IARC Participating States
    </div>

    <LayoutIarc
      v-if="is_factsheet==false"
      v-bind:website_title="'Cervical Cancer Elimination Tool'"
      v-bind:website_url="this.$store.state.env.BASE_URL"
      v-bind:website_logo="logo"
      v-bind:website_mobile_logo="logoMobile"
      v-bind:website_menu="[
        { label : 'Home' , path : '/today' , route : 'home' , 'class' : 'current' , is_home : true } , 
        { label : 'About the tool' , path : '/today/about' , route : 'about' } , 
        { label : 'Database' , path : '/today/database' , route : 'database' } , 
        { label : 'Dashboard' , path : '/today/dashboard' , route : 'dashboard' } ,
        // { label : 'Country briefs' , path : '/today/country_briefs' , route : 'country_briefs' } , 
        { label : 'Help' , path : '/today/references' , route : 'references' }
      ]"
    />
  </div>
</template>

<script>
import TheLanguageSwitcher from '@/csu-vue-components/components/TheLanguageSwitcher'
import IarcFooter from '@/csu-vue-components/components/IarcFooter.vue'
import TheMobileNavigation from '@/csu-vue-components/components/TheMobileNavigation'
import TheNavigation from '@/csu-vue-components/components/TheNavigation'
import Mobile from '@/csu-vue-components/components/Mobile'
import Theming from '@/components/Theming'
import Func from './func.js'

import LayoutIarc from '@/csu-vue-components/themes/iarc_new/Layout.vue'
import Constant from './const.js' 

export default {
  name: 'app',
  components: {
    TheNavigation , 
    IarcFooter, 
    Mobile, 
    TheMobileNavigation , 
    Theming , 
    LayoutIarc
  },
  created(){
    this.$store.commit('setEnv',process.env) ; 
    window.addEventListener("resize", this.setGraphicSizes );
    // this.handleResize();
  },
  destroyed() {
    // window.removeEventListener('resize', this.handleResize);
  },
  mounted() {

    // console.info("this.$store.state.",this.$store.state.env) ; 

    // this.findRoute();
    // $('head').append(`<link rel="stylesheet" type="text/css" href="${this.public_path}css/print.css" media="print">`) ; 

    Func.bodyClassRemove('long-read') ; 

    this.logo = require(`@/assets/img/logos/Cervical-Elimination-Blue.png`) ; 
    this.logoMobile = require(`@/assets/img/logos/Cervical-Elimination-Blue.png`) ; 

    if ( this.$store.state.ps ) 
    {
      
      this.app_classes.push('ccel')
      
      // adjust main menu
      // console.log("website_menu",this.website_menu) ; 
    }
  },
  data: function(){
    return {
        data_version : Constant.data_version , 
        route : 'home' ,
        public_path : `/${Constant.publicPath}/`,
        class_app : '' , 
        window: {
            width: 0,
            height: 0
        },
        logo : '', 
        logoMobile : '' , 
        is_factsheet : false , 
        app_classes : []
    } 
  },
  methods : {

  }
}
</script>

<style lang="scss">

$blue : #B05A3F ; 
$orange : #ffa147 ;
$green: #71BF43;

//$blue_iarc : $blue ; 
$blue_iarc : #1e7fb8 ; 
$main_color : $blue_iarc  ; 
$bg_color: $blue_iarc  ;

.multiselect__spinner{
  width: 40px;
  height: 30px !important;
}

/* a{
  &:hover{
    text-decoration: underline !important; 
    color: #B05A3F ; 
  }
}*/

.page_dashboard{

  .table.table-dashboard{
    th,td{
      text-align: right ; 
      vertical-align: top ; 
    }
  }

  & > .row-container{

    width: 100%;

    #container-filters{
      left: 60px ; 
      width: calc(100% - 60px);
    }

  }

  .container_populations{
    a.emptyPopButton{
      display: none ; 
    }
  }

  .dashboard{

    .dashboard_content{

      opacity: 1 ;
      margin-top: -10px;

      &.loading{
        opacity: 0 ; 
      }

      &.loading_temp{
        opacity: .3 ; 
      }

      i.foot{
        position: absolute;
        bottom: 25px;
        font-size: 1em;
        right: 22px;
        color: #fff ; 
      }




      .block-item{

        background: #f5f5ec ; 
        padding: 10px ; 
        min-height: 175px; 
        
        margin: 0 0 25px 0;
        border-radius: 3px;
        
        h2{
          font-weight: 800;
          text-align: left;
        }
        h3{
          display: block;
          min-height: 40px;
          font-weight: 500;
          font-size: 1.2em!important; 
          padding: 0 10px ;
          &.footnote_{
            font-style: italic ; 
            min-height: auto ; 
            text-align: center ; 
            font-weight: 400 ; 
          }
        }

        &.block-blue{
          background: $blue ;
          color: #ffffff ; 
          h2{
            color: #ffffff !important; 
            font-weight: 900!important; 
            font-size: 1.2em !important; 
          }
        }

        span.splash_none{
          display: block;
          font-weight: 600 ; 
          font-style: italic;
          font-size: 1.2em ;
          text-align: left ; 
          padding: 0px 15px ; 
        }

        span.splash{
          display: block;
          font-weight: 900 ; 
          text-align: left; 
          padding: 0px 5px ; 
          font-size: 2em ; 
          &.splash1{
            font-size: 2.6em;
          }
          &.icon::before {
            display: inline-block;
            font-style: normal;
            font-variant: normal;
            text-rendering: auto;
            -webkit-font-smoothing: antialiased;
          }
          &.dollar::before {
            font-family: "Font Awesome 5 Free";
            font-weight: 900;
            content: "\24";
          }
        }

        #viz1{
          .dash{
            position: absolute;
            left: 65px!important;
            top: 5px!important;
            svg{
              font-size: 10px!important;
            }
          }
        }

        svg{
          text{
            font-weight: 700 ; 
            font-size: 1.2em!important;
            &.annotation-note-label{
              font-size: .8em!important;
            }
          }
          text.y_title,text.x_title{
            display: none ;
          }
        }
      }

      .container_3_pillars{
        padding: 0px;
        background: transparent ;
        border-radius: 3px;
        margin: 0 0 20px 0 ; 

        .block-legend{
          font-weight: 600 ; 
          margin: 5px 0 20px 0 ;
          font-size: .9em; 
          text-align: center ; 
          i{
            color: $blue ; 
            font-size: 1em;
            font-weight: 700 ;
            display: inline-block;
            margin: 0 5px 0 0 ;
          }
        }

        .block-pillar{
          background: #fff ;
          border:solid 1px #ccc ;
          color: $blue ; 
          min-height: 170px ; 
          h2{
            color: #000 !important; 
            border-color: $blue ;
            margin-bottom: 20px; 
            i{
              font-size: .8em;
              color: #000 ; 
            }
          }

          i{
            color: #000 ; 
            font-size: 1.4em;
            font-weight: 700 ;
          }

          span.num{
            font-size: 1.6em;
            display: inline-block;
            font-weight: 900;
            padding: 0 9px;
            color: #25528F ; 
          }

          span.year,span.details{
            font-size: .8em ; 
            font-weight: 900 ; 
            letter-spacing: 2px;
            color: #ccc ; 
            display: block ; 
          }

          span.details{
            font-size: .8em ; 
            font-weight: 700 ; 
            letter-spacing: 0px;
          }

          span.details_dose{
            letter-spacing: 1px;
            font-size: 1em;
            color: #25528F;
            font-weight: 800;
          }

        }

      }

    }
  }

  .table th, .table td{
    padding: 0.5rem;
    text-align: left ; 
    vertical-align: top ; 
  }

  .table.scenario_table th, .table.scenario_table td{
    font-size: 1em;
  }

  .table-component.scenario_table{
    width: 100%;
    margin: 5px 0 ; 
    overflow-x:auto;
  }

  .container-accordion{
    
    .btn-info{
      color: #fff ;   
    }

    .col-md-3.item-accordion{
      padding: 15px 5px 0 20px ;
    }
    .item-accordion{
      padding: 15px 10px 0 20px ;
      i{
        font-size: 1.2em;
        margin: 0 5px ; 
      }
      span.num{
        font-weight: 700; 
        font-size: .9em;
      }
      span.year,span.details{
        display: block;
        font-size: .8em;
        font-weight: 400;
        letter-spacing: 2px; 
        text-align: center; 
      }
      span.details{
        font-weight: 1em;
        color: #ccc ; 
      }
    }
  }
}

.wp-caption-text{
  text-decoration: none !important ; 
  font-style: normal !important; 
  text-align: center !important ; 
}

.table-responsive{
  thead{
    background: #728cb8 ;
    th{
      color: #fff ; 
    }
  }
}

form .accordion button.btn:not(.no_collapse) {
  background: $blue !important;
}

select.select_cce{
  padding: 0.375rem 0.75rem !important;
  font-size: 13px;
  border: 1px solid #bdbdbd !important;
  letter-spacing: 1px !important;
  width: 65px !important;
  margin-left: -25px !important;
}

</style>

